// Vite: use import.meta.env.VITE_API_BASE_URL

const PRODUCTION_API_URL = 'https://api.airies.app'

export function getApiBaseUrl(): string {
  const apiBase =
    (import.meta.env.VITE_API_BASE_URL as string | undefined) ||
    (import.meta.env.VITE_API_BASE as string | undefined) ||
    PRODUCTION_API_URL
  let normalized = apiBase.trim().replace(/\/+$/, '')

  // Production safety: never use localhost in production builds
  if (import.meta.env.PROD) {
    const isLocalhost =
      normalized.includes('localhost') ||
      normalized.includes('127.0.0.1') ||
      normalized.startsWith('http://localhost') ||
      normalized.startsWith('http://127.0.0.1')
    const isMainDomain =
      normalized === 'https://airies.app' ||
      normalized === 'http://airies.app' ||
      normalized.startsWith('https://airies.app/') ||
      normalized.startsWith('http://airies.app/')

    if (isLocalhost || isMainDomain) {
      normalized = PRODUCTION_API_URL
    }
  }

  return normalized
}

export function getApiUrl(path: string): string {
  const base = getApiBaseUrl()
  const cleanPath = path.startsWith('/') ? path : `/${path}`
  if (base.endsWith('/api')) {
    return `${base}${cleanPath}`
  }
  return `${base}/api${cleanPath}`
}

/**
 * Image URLs helper.
 *
 * For your use case, all images live on the production CDN/API domain,
 * so we intentionally **do not** rewrite the host – we just trim and
 * normalise the string. This keeps image URLs pointing at
 * `https://api.airies.app/...` in every environment.
 */
export function convertApiImageUrl(imageUrl: string | null | undefined): string | null {
  if (!imageUrl || typeof imageUrl !== 'string' || !imageUrl.trim()) {
    return null
  }

  return imageUrl.trim()
}
